import React, { useState, useEffect } from 'react';
import './App.css';

const API_BASE_URL = 'https://apk.erp-imaster.uz/api';

function App() {
  const [appInfo, setAppInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [downloading, setDownloading] = useState(false);

  // Загружаем данные с сервера
  useEffect(() => {
    fetchAppInfo();
  }, []);

  const fetchAppInfo = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/app-info/`);
      
      if (!response.ok) {
        throw new Error('Не удалось загрузить информацию о приложении');
      }
      
      const data = await response.json();
      setAppInfo(data);
      setError(null);
    } catch (err) {
      console.error('Ошибка при загрузке данных:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = () => {
    setDownloading(true);
    
    // Создаем невидимую ссылку и кликаем по ней
    const link = document.createElement('a');
    link.href = `${API_BASE_URL}/download-apk/`;
    link.download = `${appInfo.name}-${appInfo.version}.apk`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Сбрасываем состояние через 1 секунду
    setTimeout(() => {
      setDownloading(false);
    }, 1000);
  };

  // Показываем состояние загрузки
  if (loading) {
    return (
      <div className="App">
        <div className="container">
          <div className="loading">
            <div className="spinner"></div>
            <p>Загрузка информации о приложении...</p>
          </div>
        </div>
      </div>
    );
  }

  // Показываем ошибку
  if (error) {
    return (
      <div className="App">
        <div className="container">
          <div className="error-message">
            <h2>⚠️ Ошибка</h2>
            <p>{error}</p>
            <button className="retry-button" onClick={fetchAppInfo}>
              Попробовать снова
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Показываем сообщение если файл не найден
  if (!appInfo.file_exists) {
    return (
      <div className="App">
        <div className="container">
          <div className="error-message">
            <h2>📱 {appInfo.name}</h2>
            <p>⚠️ APK файл не найден на сервере</p>
            <p style={{fontSize: '14px', color: '#666', marginTop: '10px'}}>
              Администратор должен загрузить файл на сервер
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="play-store-container">
        {/* Header Section */}
        <header className="play-header">
          <div className="play-header-content">
            <div className="play-icon">
              {appInfo.icon_url ? (
                <img 
                  src={`${API_BASE_URL}${appInfo.icon_url}`} 
                  alt={appInfo.name}
                  className="play-icon-img"
                />
              ) : (
                <div className="play-icon-placeholder">📱</div>
              )}
            </div>
            
            <div className="play-header-info">
              <h1 className="play-app-name">{appInfo.name}</h1>
              <p className="play-developer">{appInfo.developer || 'Developer Name'}</p>
              {appInfo.contains_ads && <p className="play-ads">Есть реклама</p>}
            </div>
          </div>

          {/* Stats */}
          <div className="play-stats">
            <div className="play-stat">
              <div className="play-stat-value">{appInfo.rating || '4.6'}★</div>
              <div className="play-stat-label">Отзывы: {appInfo.reviews_count || '1,8 млн'}</div>
            </div>
            <div className="play-stat">
              <div className="play-stat-value">{appInfo.downloads || '100 млн+'}</div>
              <div className="play-stat-label">(количество скачиваний)</div>
            </div>
            <div className="play-stat">
              <div className="play-stat-value">
                <span className="age-badge">{appInfo.age_rating || '3+'}</span>
              </div>
              <div className="play-stat-label">{appInfo.age_rating || '3+'} ⓘ</div>
            </div>
          </div>

          {/* Action Button */}
          <div className="play-actions">
            <button
              className={`play-install-btn ${downloading ? 'downloading' : ''}`}
              onClick={handleDownload}
              disabled={downloading}
            >
              {downloading ? 'Скачивание...' : 'Установить'}
            </button>
          </div>


        </header>

        {/* Screenshots */}
        {appInfo.screenshots && appInfo.screenshots.length > 0 && (
          <section className="play-screenshots">
            <div className="play-screenshots-scroll">
              {appInfo.screenshots.map((screenshot, index) => (
                <img 
                  key={index}
                  src={`${API_BASE_URL}${screenshot}`} 
                  alt={`Screenshot ${index + 1}`}
                  className="play-screenshot-img"
                />
              ))}
            </div>
          </section>
        )}

        {/* About Section */}
        <section className="play-section">
          <h2 className="play-section-title">
            Описание
            <span className="arrow">→</span>
          </h2>
          <p className="play-description">{appInfo.description}</p>
          {appInfo.update_date && (
            <div className="play-update">
              <h3>Последнее обновление</h3>
              <p>{appInfo.update_date}</p>
            </div>
          )}
        </section>

        {/* Tags */}
        {appInfo.tags && appInfo.tags.length > 0 && (
          <div className="play-tags">
            {appInfo.tags.map((tag, index) => (
              <span key={index} className="play-tag">{tag}</span>
            ))}
          </div>
        )}

        {/* Reviews Section */}
        {appInfo.reviews && appInfo.reviews.length > 0 && (
          <section className="play-section">
            <div className="play-reviews-header">
              <h2 className="play-section-title">
                Оценки и отзывы
                <span className="arrow">→</span>
              </h2>
              <span className="play-verified">Оценки и отзывы проверены ⓘ</span>
            </div>

            {/* Rating Summary */}
            <div className="play-rating-summary">
              <div className="play-rating-big">
                <div className="play-rating-number">{appInfo.rating || '4.6'}</div>
                <div className="play-stars">★★★★½</div>
                <div className="play-rating-count">{appInfo.reviews_count || '1,58 млн'} отзыв</div>
              </div>
              
              <div className="play-rating-bars">
                {[5, 4, 3, 2, 1].map((star) => (
                  <div key={star} className="play-rating-bar">
                    <span className="bar-label">{star}</span>
                    <div className="bar-container">
                      <div 
                        className="bar-fill" 
                        style={{width: `${appInfo.rating_distribution?.[star] || (star === 5 ? 85 : star === 4 ? 10 : 3)}%`}}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Individual Reviews */}
            <div className="play-reviews-list">
              {appInfo.reviews.map((review, index) => (
                <div key={index} className="play-review">
                  <div className="play-review-header">
                    <div className="play-review-avatar">{review.author[0]}</div>
                    <div className="play-review-author">
                      <div className="play-review-name">{review.author}</div>
                      <div className="play-review-stars">
                        {'★'.repeat(review.rating)}{'☆'.repeat(5 - review.rating)}
                        <span className="play-review-date">{review.date}</span>
                      </div>
                    </div>
                    <button className="play-review-menu">⋮</button>
                  </div>
                  <p className="play-review-text">{review.text}</p>
                  {review.helpful_count && (
                    <p className="play-review-helpful">
                      {review.helpful_count} человека отметили этот отзыв как полезный.
                    </p>
                  )}
                  {review.developer_response && (
                    <div className="play-developer-response">
                      <div className="play-response-header">
                        <strong>{appInfo.developer || 'Developer'}</strong>
                        <span className="play-response-date">{review.developer_response.date}</span>
                      </div>
                      <p>{review.developer_response.text}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </section>
        )}

        {/* App Info Footer */}
        <footer className="play-footer">
          <div className="play-info-row">
            <span className="play-info-label">Размер</span>
            <span className="play-info-value">{appInfo.size}</span>
          </div>
          <div className="play-info-row">
            <span className="play-info-label">Версия</span>
            <span className="play-info-value">{appInfo.version}</span>
          </div>
          {appInfo.requirements && (
            <div className="play-info-row">
              <span className="play-info-label">Требуется Android</span>
              <span className="play-info-value">{appInfo.requirements.min_android_version} и выше</span>
            </div>
          )}
        </footer>
      </div>
    </div>
  );
}

export default App;
